module.exports = __webpack_public_path__ + "static/media/auth1.871eadb7.svg";